/* Collection V2 desktop dropdown clearance; leave tablet and mobile layout unchanged. */
(() => {
  const setup = () => {
    const page = document.querySelector('.banditos-collection-v2');
    const nav = document.querySelector('.section-header-navigation .header__inline-menu');
    if (!page || !nav || page.dataset.menuSpaceReady) return;
    page.dataset.menuSpaceReady = 'true';
    const updateMobileFilterTop = () => {
      if (!window.matchMedia('(max-width:767px)').matches) return;
      const toolbar = page.querySelector('.toolbar');
      if (!toolbar) return;
      const top = Math.max(0, Math.min(toolbar.getBoundingClientRect().top, window.innerHeight - 180));
      document.body.style.setProperty('--collection-mobile-filter-top', Math.round(top) + 'px');
    };
    page.addEventListener('click', event => {
      if (event.target.closest('.toolbar-sidebar[data-sidebar]')) updateMobileFilterTop();
    }, true);
    window.addEventListener('resize', () => {
      if (document.body.classList.contains('open-mobile-sidebar')) updateMobileFilterTop();
    }, {passive:true});
    const closeOptionalFilters = () => {
      const specificCollection = /\/collections\/(?!all(?:\/|$))[^/]+\/?$/.test(window.location.pathname);
      page.classList.toggle('collection-specific-compact', specificCollection);
      page.querySelectorAll('.sidebarBlock').forEach(block => {
        const heading = block.querySelector('.sidebarBlock-heading');
        const label = heading?.querySelector('.facets__text')?.textContent.trim().toLowerCase();
        if (window.matchMedia('(max-width:767px)').matches) {
          if (block.classList.contains('sidebar-categories') || !heading || !block.querySelector('.sidebarBlock-contentWrapper')) return;
        } else if (window.matchMedia('(min-width:1281px)').matches && specificCollection) {
          if (block.classList.contains('sidebar-categories') || !heading || !block.querySelector('.sidebarBlock-contentWrapper')) return;
        } else if (!['shop by product type','shop by color','shop by size','age group'].includes(label)) return;
        heading.classList.remove('is-clicked');
        const content = block.querySelector('.sidebarBlock-contentWrapper');
        if (content) content.style.display = 'none';
      });
    };
    closeOptionalFilters();
    if (document.readyState !== 'complete') window.addEventListener('load', closeOptionalFilters, {once:true});
    const desktop = window.matchMedia('(min-width: 1281px)');
    const url = new URL(window.location.href);
    const filterForm = page.querySelector('#CollectionFiltersForm');
    if (filterForm) {
      for (const key of ['view', 'pb', 'preview_theme_id']) {
        if (!url.searchParams.has(key)) continue;
        let input = filterForm.querySelector('input[name="' + key + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          filterForm.appendChild(input);
        }
        input.value = url.searchParams.get(key);
      }
    }

    if (window.matchMedia('(min-width: 768px)').matches && !url.searchParams.has('sort_by')) {
      url.searchParams.set('sort_by', 'best-selling');
      window.location.replace(url.href);
      return;
    }
{
      page.querySelectorAll('.page-sidebar a.navPages-action[href*="/collections/"]').forEach(link => {
        const target = new URL(link.href, window.location.origin);
        if (target.origin !== window.location.origin) return;
        if (target.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '')) {
          link.setAttribute('aria-current', 'page');
        }
        // Keep navigation inside this V2 preview instead of returning to the original template.
        target.searchParams.set('view', url.searchParams.get('view') || 'v2');
        for (const key of ['preview_theme_id', 'pb']) {
          if (url.searchParams.has(key)) target.searchParams.set(key, url.searchParams.get(key));
        }
        target.searchParams.set('sort_by', url.searchParams.get('sort_by') || 'best-selling');
        link.href = target.pathname + target.search;
      });
    }
let collectionRequest;
    const loadCollection = async (destination, push = true) => {
      collectionRequest?.abort();
      const request = new AbortController();
      collectionRequest = request;
      const content = page.querySelector('.page-content');
      content.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(destination, { signal: request.signal });
        if (!response.ok) throw new Error('Collection unavailable');
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!parsed.querySelector('#CollectionProductGrid .collection')) throw new Error('Collection missing');
        const filters = customElements.get('collection-filters-form');
        if (!filters) throw new Error('Filters unavailable');
        filters.renderFilters(html);
        filters.renderProductGrid(html);
        const heading = parsed.querySelector('.banditos-collection-v2__intro h1');
        if (heading) page.querySelector('.banditos-collection-v2__intro h1').textContent = heading.textContent;
        document.title = parsed.title;
        const next = new URL(destination, location.origin);
        if (push) history.pushState({ searchParams: next.searchParams.toString() }, '', next.href);
        filters.searchParamsPrev = next.searchParams.toString();
        closeOptionalFilters();
        page.querySelectorAll('.page-sidebar a.navPages-action').forEach(link => {
          if (new URL(link.href).pathname === next.pathname) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        const selected = parsed.querySelector('.filter-sortby .label-text');
        if (selected) page.querySelector('.filter-sortby .label-text').textContent = selected.textContent;
        page.querySelectorAll('.filter-sortby [data-sort-by-item]').forEach(item => {
          item.classList.toggle('is-active', item.querySelector('[data-value]').dataset.value === next.searchParams.get('sort_by'));
        });
        const sortSelect = page.querySelector('[name=sort_by]');
        if (sortSelect) sortSelect.value = next.searchParams.get('sort_by');
        let viewInput = page.querySelector('#CollectionFiltersForm input[name=view]');
        if (!viewInput && next.searchParams.has('view')) {
          viewInput = document.createElement('input');
          viewInput.type = 'hidden'; viewInput.name = 'view';
          page.querySelector('#CollectionFiltersForm').appendChild(viewInput);
        }
        if (viewInput) viewInput.value = next.searchParams.get('view') || '';
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(destination);
      } finally {
        if (collectionRequest === request) content.removeAttribute('aria-busy');
      }
    };
    page.addEventListener('click', event => {
      const link = event.target.closest('.page-sidebar a.navPages-action[href*="/collections/"], a.js-facet-remove, #CollectionProductGrid .title a[href*="/collections/"]');
      if (!desktop.matches || !link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const target = new URL(link.href, location.origin);
      if (target.origin !== location.origin) return;
      const current = new URL(location.href);
      target.searchParams.set('view', current.searchParams.get('view') || 'v2');
      for (const key of ['preview_theme_id', 'pb']) {
        if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
      }
      if (!target.searchParams.has('sort_by')) target.searchParams.set('sort_by', current.searchParams.get('sort_by') || 'best-selling');
      loadCollection(target.href);
    }, true);
    window.addEventListener('popstate', event => {
      if (!desktop.matches) return;
      event.stopImmediatePropagation();
      loadCollection(window.location.href, false);
    }, true);
    const sort = page.querySelector('.filter-sortby');
    if (sort) {
      const list = sort.querySelector('ul');
      ['best-selling', 'most-relevant', 'manual', 'created-descending', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending', 'created-ascending'].forEach(value => {
        const item = list.querySelector('[data-value="' + value + '"]')?.closest('li');
        if (item) list.appendChild(item);
      });
      const toggle = sort.querySelector('[aria-expanded]');
      toggle.setAttribute('aria-label', 'Open or close sorting options');
      sort.addEventListener('keydown', event => {
        if (event.key === 'Escape') { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
        if (event.target === toggle && ['Enter', ' '].includes(event.key)) { event.preventDefault(); toggle.click(); }
      });
      list.addEventListener('click', event => {
        const item = event.target.closest('[data-sort-by-item]');
        if (!item) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('sort_by', item.querySelector('[data-value]').dataset.value);
        nextUrl.searchParams.delete('page');
        toggle.setAttribute('aria-expanded', 'false');
        if (nextUrl.href !== window.location.href) {
          if (desktop.matches) loadCollection(nextUrl.href);
          else window.location.assign(nextUrl.href);
        }
      }, true);
    }
    let frame = 0, until = 0, shift = 0;
    const update = () => {
      frame = 0;
      page.style.setProperty('--collection-header-space', Math.round(page.getBoundingClientRect().top + window.scrollY) + 'px');

      if (window.matchMedia('(min-width:768px) and (max-width:1280px)').matches) {
        const heading = page.querySelector('.sidebar-categories .sidebarBlock-heading');
        const photo = page.querySelector('#main-collection-product-grid .card-media');
        if (heading && photo) {
          const currentOffset = parseFloat(page.style.getPropertyValue('--tablet-grid-offset')) || 0;
          const offset = Math.max(0, Math.round(heading.getBoundingClientRect().top - photo.getBoundingClientRect().top + currentOffset));
          if (Math.abs(offset - currentOffset) > .5) page.style.setProperty('--tablet-grid-offset', offset + 'px');
        }
      }
      let next = 0;
      const container = page.querySelector('.banditos-collection-v2__intro');
      if (desktop.matches && window.scrollY <= 4 && container && nav.getClientRects().length) {
        const closedTop = container.getBoundingClientRect().top - shift;
        let bottom = 0;
        nav.querySelectorAll('.menu-lv-1 > .menu-dropdown').forEach(drop => {
          const css = getComputedStyle(drop);
          if (css.display !== 'none' && css.visibility !== 'hidden' && Number(css.opacity) > .01)
            bottom = Math.max(bottom, drop.getBoundingClientRect().bottom);
        });
        next = bottom ? Math.max(0, Math.ceil(bottom + 16 - closedTop)) : 0;
      }
      if (next !== shift) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        shift = reduced || Math.abs(next - shift) < .5 ? next : shift + (next - shift) * .18;
        page.style.setProperty('--collection-menu-space', shift + 'px');
      }
      if (performance.now() < until || next !== shift) frame = requestAnimationFrame(update);
    };
    const schedule = () => {
      until = performance.now() + 500;
      if (!frame) frame = requestAnimationFrame(update);
    };
    document.fonts.ready.then(schedule);
    const tabletSizeObserver = new ResizeObserver(schedule);
    tabletSizeObserver.observe(page.querySelector('.page-sidebar'));
    const events = ['pointerover', 'pointerout', 'focusin', 'focusout', 'click'];
    events.forEach(type => nav.addEventListener(type, schedule));
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    const observer = new MutationObserver(schedule);
    observer.observe(nav, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-expanded'] });
    document.addEventListener('shopify:section:unload', function cleanup(event) {
      if (!event.target.contains(page)) return;
      cancelAnimationFrame(frame);
      observer.disconnect();
      tabletSizeObserver.disconnect();
      events.forEach(type => nav.removeEventListener(type, schedule));
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule);
      document.removeEventListener('shopify:section:unload', cleanup);
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
